import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { NotifService } from '../../core/notification/notif.service';

@Component({
    selector: 'map-sso-callback',
    templateUrl: './sso-callback.component.html',
    styleUrls: ['./sso-callback.component.scss']
})
export class SsoCallbackComponent implements OnInit {
    displayError = false;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly notifService: NotifService
    ) {}

    ngOnInit(): void {
        console.log('SSO Callback component loaded');
        console.log('Current URL:', window.location.href);

        this.route.queryParams.subscribe(
            params => {
                console.log('Query params:', params);
                const ssoToken = params['token'];

                if (!ssoToken) {
                    // Token not present
                    console.error('SSO token is missing from query params');
                    this.displayError = true;
                    this.notifService.error('SSO token is missing');
                    setTimeout(() => this.router.navigate(['/public/login']), 2000);
                    return;
                }

                console.log('SSO token received:', ssoToken.substring(0, 20) + '...');

                this.authService.confirmSsoToken(ssoToken).subscribe({
                    next: (loginResponse) => {
                        console.log('SSO login successful', loginResponse);
                        const homePage = this.authService.getHomePageForUser();
                        this.router.navigate([homePage]);
                    },
                    error: (error) => {
                        console.error('SSO confirmation failed:', error);
                        this.displayError = true;
                        this.notifService.error('Failed to authenticate with SSO token');
                        setTimeout(() => this.router.navigate(['/public/login']), 2000);
                    }
                });
            }
        );
    }
}
